module.exports = __webpack_public_path__ + "static/img/0757.59f7108.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0757.jpg
// module id = 96
// module chunks = 0